<div class="interface-container">
  <div class="left-section">
    <div class="box left-box left-panel">
      <!-- Contrôles technicien + date -->
      <div class="panel-header-compact">
        <p-dropdown
          [options]="users"
          [filter]="true"
          placeholder="Technicien"
          [(ngModel)]="selectedUser"
          (ngModelChange)="loadEventsForToday(); updateUserSelect()"
          [style]="{ width: '100%' }"
          class="tech-dropdown"
        >
        </p-dropdown>

        <div class="date-nav-row">
          <div class="date-nav-buttons">
            <p-button
              icon="pi pi-chevron-left"
              [text]="true"
              size="small"
              (click)="goToPreviousDay()"
              pTooltip="Jour précédent"
            ></p-button>
            <p-button
              label="Auj."
              [text]="true"
              size="small"
              (click)="goToToday()"
              class="today-btn"
            ></p-button>
            <p-button
              icon="pi pi-chevron-right"
              [text]="true"
              size="small"
              (click)="goToNextDay()"
              pTooltip="Jour suivant"
            ></p-button>
          </div>
          <p-calendar
            [(ngModel)]="selectedDate"
            (onSelect)="onDateChange()"
            [showIcon]="true"
            [iconDisplay]="'input'"
            [readonlyInput]="true"
            dateFormat="dd/mm/yy"
            [style]="{ width: '130px' }"
            placeholder="Date"
            [appendTo]="'body'"
          ></p-calendar>
        </div>
        <div class="date-label">{{ getFormattedDate() }}</div>
      </div>

      <!-- Calendrier -->
      <div class="calendar-section">
        <full-calendar #calendar [options]="calendarOptions"></full-calendar>
      </div>

      <!-- Récap journée -->
      <div class="daily-summary" *ngIf="allInterventions.length > 0">
        <div class="summary-header">
          <div class="summary-title">
            <i class="pi pi-list"></i>
            <span>Récap journée</span>
            <span class="intervention-count">{{
              allInterventions.length
            }}</span>
          </div>
          <div class="summary-totals" *ngIf="distanceMatrix">
            <span class="total-badge distance-badge">
              <i class="pi pi-map"></i>
              {{ getCurrentRouteDistance().distance.toFixed(1) }} km
            </span>
            <span class="total-badge time-badge">
              <i class="pi pi-clock"></i>
              {{ formatDuration(getCurrentRouteDistance().duration) }}
            </span>
          </div>
        </div>

        <!-- Résumé départ/retour -->
        <div class="time-summary" *ngIf="getDailySummary().departureTime">
          <div class="time-summary-item">
            <i class="pi pi-sign-out"></i>
            <span>Départ</span>
            <strong>{{ formatTime(getDailySummary().departureTime) }}</strong>
          </div>
          <div class="time-summary-separator">→</div>
          <div class="time-summary-item">
            <i class="pi pi-sign-in"></i>
            <span>Retour</span>
            <strong>{{ formatTime(getDailySummary().arrivalTime) }}</strong>
          </div>
        </div>

        <div class="timeline-container">
          <ng-container
            *ngFor="
              let step of getDailySummary().steps;
              let i = index;
              let last = last
            "
          >
            <!-- Trajet (sauf avant départ domicile) -->
            <div
              class="travel-segment"
              *ngIf="step.type === 'intervention' && step.travelDuration > 0"
            >
              <div class="travel-line"></div>
              <div class="travel-info">
                <i class="pi pi-car"></i>
                <span>{{ formatDuration(step.travelDuration) }}</span>
                <span class="travel-distance" *ngIf="step.distance > 0"
                  >· {{ step.distance.toFixed(1) }} km</span
                >
              </div>
            </div>

            <!-- Trajet retour -->
            <div
              class="travel-segment"
              *ngIf="step.type === 'home-arrival' && step.travelDuration > 0"
            >
              <div class="travel-line"></div>
              <div class="travel-info">
                <i class="pi pi-car"></i>
                <span>{{ formatDuration(step.travelDuration) }}</span>
                <span class="travel-distance" *ngIf="step.distance > 0"
                  >· {{ step.distance.toFixed(1) }} km</span
                >
              </div>
            </div>

            <!-- Étape -->
            <div
              class="timeline-step"
              [class.home-step]="
                step.type === 'home-departure' || step.type === 'home-arrival'
              "
              [class.intervention-step]="step.type === 'intervention'"
              [class.selected]="
                step.intervention &&
                selectedIntervention &&
                step.intervention?.data?.id === selectedIntervention?.data?.id
              "
              (click)="
                step.intervention && handleTimelineClick(step.intervention)
              "
            >
              <div class="step-marker">
                <div
                  class="marker-dot"
                  [class.home-dot]="
                    step.type === 'home-departure' ||
                    step.type === 'home-arrival'
                  "
                  [class.intervention-dot]="step.type === 'intervention'"
                >
                  <i
                    *ngIf="
                      step.type === 'home-departure' ||
                      step.type === 'home-arrival'
                    "
                    class="pi pi-home"
                  ></i>
                  <span *ngIf="step.type === 'intervention'">{{
                    step.interventionNumber
                  }}</span>
                </div>
              </div>

              <div class="step-time">
                <span class="time-value">{{ formatTime(step.time) }}</span>
                <span class="time-end" *ngIf="step.endTime">{{
                  formatTime(step.endTime)
                }}</span>
              </div>

              <div class="step-details">
                <span class="step-title">{{ step.title }}</span>
                <span class="step-locality" *ngIf="step.locality">{{
                  step.locality
                }}</span>
                <span
                  class="step-duration-tag"
                  *ngIf="step.interventionDuration > 0"
                >
                  {{ formatDuration(step.interventionDuration) }}
                </span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div
        class="no-interventions-summary"
        *ngIf="allInterventions.length === 0 && selectedUser"
      >
        <i class="pi pi-calendar-times"></i>
        <span>Aucune intervention prévue</span>
      </div>
    </div>
  </div>

  <div class="middle-section">
    <div
      class="box middle-box-small intervention-card"
      *ngIf="interventionInfo; else noIntervention"
    >
      <!-- En-tête avec statut et source -->
      <div class="intervention-header">
        <div class="status-badges">
          <p-tag
            severity="info"
            [value]="interventionInfo.interventionStatus.name"
            styleClass="status-tag"
          />
          <p-tag
            severity="success"
            [value]="interventionInfo.erpSource.toUpperCase()"
            styleClass="source-tag"
          />
        </div>
        <h2 class="intervention-title">
          <i class="pi pi-briefcase" style="margin-right: 5px"></i>
          {{ interventionInfo.name }}
        </h2>
      </div>

      <!-- Contenu principal avec sections -->
      <div class="intervention-content">
        <!-- Section adresse -->
        <div class="info-section">
          <div class="info-text">
            <i class="pi pi-map-marker" style="margin-right: 5px"></i>
            <strong>{{ interventionInfo.affair.workSiteAddress }}</strong
            >, {{ interventionInfo.affair.workSiteLocality }}
            {{ interventionInfo.affair.workSitePostalCode }}
          </div>
        </div>

        <!-- Section dates -->
        <div class="info-section date-time">
          <div class="time-item">
            <div class="info-text">
              <i class="pi pi-calendar-plus" style="margin-right: 5px"></i>
              <strong>Début:</strong>
              {{ interventionInfo.startDate | date: 'short' }}
            </div>
          </div>
          <div class="time-item">
            <div class="info-text">
              <i class="pi pi-clock" style="margin-right: 5px"></i>
              <strong>Durée:</strong> {{ interventionInfo.duration }}
            </div>
          </div>
          <div class="time-item">
            <div class="info-text">
              <i class="pi pi-calendar-minus" style="margin-right: 5px"></i>
              <strong>Fin:</strong>
              {{ interventionInfo.endDate | date: 'short' }}
            </div>
          </div>
        </div>

        <!-- Section techniciens -->
        <div
          class="info-section"
          *ngIf="interventionInfo.usersTechnicians?.length > 0"
        >
          <div class="info-text">
            <i class="pi pi-users" style="margin-right: 5px"></i>
            <strong>Techniciens:</strong>
            <div class="tech-list">
              <div
                class="tech-item"
                *ngFor="let tech of interventionInfo.usersTechnicians"
              >
                <div
                  class="rounded-full w-4 h-4"
                  [style.background-color]="tech.color"
                ></div>
                {{ tech.firstname }} {{ tech.lastname }}
                <small>({{ tech.email }})</small>
              </div>
            </div>
          </div>
        </div>

        <!-- Section assistant -->
        <div class="info-section" *ngIf="interventionInfo.userAssistant">
          <div class="info-text">
            <i class="pi pi-user" style="margin-right: 5px"></i>
            <strong>Assistant:</strong>
            {{ interventionInfo.userAssistant.firstname }}
            {{ interventionInfo.userAssistant.lastname }}
          </div>
        </div>
      </div>
    </div>

    <ng-template #noIntervention>
      <div class="box middle-box-small no-intervention">
        <i class="pi pi-info-circle" style="margin-right: 5px"></i>
        <span>Aucune intervention sélectionnée</span>
      </div>
    </ng-template>

    <div class="box middle-box-large">
      <app-route-map
        #routeMap
        [routeData]="routeInfo"
        [optimizedRouteData]="optimizedRouteInfo"
        [interventions]="allInterventions"
        [selectedUser]="selectedUserObject"
      ></app-route-map>
    </div>
  </div>

  <div class="right-section">
    <!-- Section Comparaison des Itinéraires -->
    <div class="box right-box route-info-card comparison-card">
      <div class="route-card-header">
        <div class="route-header-content">
          <i class="pi pi-map route-icon"></i>
          <h3>Comparaison des Itinéraires</h3>
        </div>
        <div class="route-header-buttons">
          <p-button
            *ngIf="
              allInterventions &&
              allInterventions.length > 0 &&
              selectedUserObject
            "
            icon="pi pi-map-marker"
            [text]="true"
            [rounded]="true"
            size="small"
            (onClick)="openGoogleMapsRoute()"
            pTooltip="Ouvrir dans Google Maps"
            class="google-maps-btn"
            severity="success"
          ></p-button>
          <p-button
            *ngIf="routeInfo || optimizedRouteInfo || distanceMatrix"
            icon="pi pi-external-link"
            [text]="true"
            [rounded]="true"
            size="small"
            (onClick)="openRouteDetailsModal()"
            pTooltip="Voir détails complets"
            class="details-btn"
          ></p-button>
        </div>
      </div>

      <div class="route-content">
        <div
          *ngIf="!routeInfo && !optimizedRouteInfo && !distanceMatrix"
          class="no-data-state"
        >
          <i class="pi pi-info-circle no-data-icon"></i>
          <span>Aucune intervention sélectionnée</span>
        </div>

        <div
          *ngIf="routeInfo || optimizedRouteInfo || distanceMatrix"
          class="routes-comparison"
        >
          <!-- Itinéraire Actuel -->
          <div
            class="route-column"
            [class.disabled]="!routeInfo && !distanceMatrix"
          >
            <div class="route-column-header">
              <i class="pi pi-map-marker route-column-icon current"></i>
              <span class="route-column-title">Actuel</span>
            </div>

            <div
              *ngIf="!routeInfo && !distanceMatrix"
              class="route-unavailable"
            >
              <span>Non disponible</span>
            </div>

            <div
              *ngIf="routeInfo || distanceMatrix"
              class="route-stats-compact"
            >
              <div class="stat-compact">
                <i class="pi pi-map-marker stat-icon"></i>
                <span class="stat-value">
                  {{
                    distanceMatrix
                      ? getCurrentRouteDistance().distance.toFixed(1)
                      : routeInfo?.summary?.distance_km || 0
                  }}
                  km
                </span>
              </div>
              <div class="stat-compact">
                <i class="pi pi-clock stat-icon"></i>
                <span class="stat-value">
                  {{
                    formatDuration(
                      distanceMatrix
                        ? getCurrentRouteDistance().duration
                        : routeInfo?.summary?.duration_min || 0
                    )
                  }}
                </span>
              </div>
            </div>
          </div>

          <!-- Séparateur -->
          <div class="routes-separator">
            <i class="pi pi-angle-right"></i>
          </div>

          <!-- Itinéraire Optimisé -->
          <div class="route-column" [class.disabled]="!optimizedRouteInfo">
            <div class="route-column-header">
              <i class="pi pi-chart-line route-column-icon optimized"></i>
              <span class="route-column-title">Optimisé</span>
            </div>

            <div *ngIf="!optimizedRouteInfo" class="route-unavailable">
              <span>Non disponible</span>
            </div>

            <div *ngIf="optimizedRouteInfo" class="route-stats-compact">
              <div class="stat-compact">
                <i class="pi pi-map-marker stat-icon"></i>
                <span class="stat-value"
                  >{{ optimizedRouteInfo.summary.distance_km }} km</span
                >
              </div>
              <div class="stat-compact">
                <i class="pi pi-clock stat-icon"></i>
                <span class="stat-value">{{
                  formatDuration(optimizedRouteInfo.summary.duration_min)
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Économies réalisées -->
        <div class="savings-summary" *ngIf="routeInfo && optimizedRouteInfo">
          <div class="savings-summary-header">
            <i class="pi pi-chart-bar"></i>
            <span>Économies</span>
          </div>

          <div class="savings-items">
            <div
              class="savings-item-compact distance-savings"
              *ngIf="
                routeInfo.summary.distance_km >
                optimizedRouteInfo.summary.distance_km
              "
            >
              <i class="pi pi-arrow-down savings-icon"></i>
              <span class="savings-value">
                -{{
                  (
                    routeInfo.summary.distance_km -
                    optimizedRouteInfo.summary.distance_km
                  ).toFixed(1)
                }}
                km
              </span>
            </div>

            <div
              class="savings-item-compact time-savings"
              *ngIf="
                routeInfo.summary.duration_min >
                optimizedRouteInfo.summary.duration_min
              "
            >
              <i class="pi pi-arrow-down savings-icon"></i>
              <span class="savings-value">
                -{{
                  (
                    routeInfo.summary.duration_min -
                    optimizedRouteInfo.summary.duration_min
                  ).toFixed(0)
                }}
                min
              </span>
            </div>

            <div
              class="savings-item-compact optimal-item"
              *ngIf="
                routeInfo.summary.distance_km <=
                  optimizedRouteInfo.summary.distance_km &&
                routeInfo.summary.duration_min <=
                  optimizedRouteInfo.summary.duration_min
              "
            >
              <i class="pi pi-check-circle savings-icon"></i>
              <span class="optimal-text">Déjà optimal</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section Modifications -->
    <div
      class="box right-box modifications-card"
      *ngIf="(optimizedRouteInfo && !isRouteOptimal()) || loadingOptimizedRoute"
    >
      <div class="route-card-header">
        <div class="route-header-content">
          <i class="pi pi-refresh route-icon modifications"></i>
          <h3>Modifications Suggérées</h3>
          <span
            *ngIf="getModificationsCount() > 0 && !loadingOptimizedRoute"
            class="modifications-count-badge"
          >
            {{ getModificationsCount() }}
          </span>
        </div>
        <div class="route-header-buttons">
          <p-button
            *ngIf="getModificationsCount() > 0 && !loadingOptimizedRoute"
            icon="pi pi-check-circle"
            [text]="true"
            [rounded]="true"
            size="small"
            (onClick)="confirmApplyAllModifications()"
            [disabled]="
              applyingAllModifications || swappingInterventionIndex !== null
            "
            [loading]="applyingAllModifications"
            pTooltip="Tout appliquer"
            class="apply-all-btn"
            severity="warn"
          ></p-button>
          <p-button
            *ngIf="
              optimizedRouteInfo?.optimizedOrder &&
              optimizedRouteInfo.optimizedOrder.length > 0 &&
              selectedUserObject
            "
            icon="pi pi-map-marker"
            [text]="true"
            [rounded]="true"
            size="small"
            (onClick)="openOptimizedGoogleMapsRoute()"
            pTooltip="Ouvrir l'itinéraire optimisé dans Google Maps"
            class="google-maps-btn"
            severity="success"
          ></p-button>
        </div>
      </div>

      <div class="route-content">
        <!-- Loading state -->
        <div *ngIf="loadingOptimizedRoute" class="loading-state">
          <i class="pi pi-spin pi-spinner loading-spinner"></i>
          <span>Calcul de l'itinéraire optimisé...</span>
        </div>

        <div
          *ngIf="!loadingOptimizedRoute && !optimizedRouteInfo"
          class="no-data-state"
        >
          <i class="pi pi-info-circle no-data-icon"></i>
          <span>Optimisation en attente</span>
        </div>

        <div *ngIf="!loadingOptimizedRoute && optimizedRouteInfo">
          <div
            *ngIf="
              !optimizedRouteInfo.optimizedOrder ||
              optimizedRouteInfo.optimizedOrder.length === 0
            "
            class="no-modifications"
          >
            <div class="success-state">
              <i class="pi pi-check-circle success-icon"></i>
              <span>Aucune modification nécessaire</span>
              <small>L'itinéraire est déjà optimal</small>
            </div>
          </div>

          <div
            class="modifications-list"
            *ngIf="
              optimizedRouteInfo.optimizedOrder &&
              optimizedRouteInfo.optimizedOrder.length > 0
            "
          >
            <div
              *ngFor="let order of optimizedRouteInfo.optimizedOrder"
              class="modification-item"
              [class.has-change]="order.position !== order.originalIndex"
            >
              <div
                *ngIf="order.position !== order.originalIndex"
                class="modification-content"
              >
                <div class="modification-info">
                  <div class="intervention-title">
                    {{ order.title }}
                    <i
                      *ngIf="isDoNotShift(order.originalIndex)"
                      class="pi pi-lock do-not-shift-icon"
                      pTooltip="Ne pas décaler"
                    ></i>
                  </div>
                  <div class="intervention-locality">{{ order.locality }}</div>
                  <div class="position-change">
                    <span class="position-badge from">{{
                      order.originalIndex + 1
                    }}</span>
                    <i class="pi pi-arrow-right arrow-icon"></i>
                    <span class="position-badge to">{{
                      order.position + 1
                    }}</span>
                  </div>
                </div>
                <button
                  pButton
                  [icon]="
                    swappingInterventionIndex === order.originalIndex
                      ? 'pi pi-spin pi-spinner'
                      : 'pi pi-refresh'
                  "
                  class="p-button-sm p-button-outlined modification-btn"
                  [disabled]="
                    swappingInterventionIndex !== null ||
                    applyingAllModifications
                  "
                  (click)="
                    moveIntervention(order.originalIndex, order.position)
                  "
                  pTooltip="Appliquer cette modification"
                >
                  {{
                    swappingInterventionIndex === order.originalIndex
                      ? 'En cours...'
                      : 'Inverser'
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <p-confirmDialog></p-confirmDialog>

  <!-- Modale pour les détails de l'itinéraire -->
  <p-dialog
    [(visible)]="showRouteDetailsModal"
    [modal]="true"
    [closable]="true"
    [resizable]="true"
    [style]="{ width: '80vw', maxWidth: '800px' }"
    header="Détails de l'itinéraire"
    (onHide)="closeRouteDetailsModal()"
  >
    <div class="route-details-modal" *ngIf="routeInfo || distanceMatrix">
      <!-- Résumé de l'itinéraire -->
      <div class="route-summary-section">
        <h3><i class="pi pi-info-circle"></i> Résumé</h3>
        <div class="summary-grid">
          <div class="summary-item">
            <span class="label">Distance totale:</span>
            <span class="value">
              {{
                distanceMatrix
                  ? getCurrentRouteDistance().distance.toFixed(1)
                  : routeInfo?.summary?.distance_km || 0
              }}
              km
            </span>
          </div>
          <div class="summary-item">
            <span class="label">Durée estimée:</span>
            <span class="value">{{
              formatDuration(
                distanceMatrix
                  ? getCurrentRouteDistance().duration
                  : routeInfo?.summary?.duration_min || 0
              )
            }}</span>
          </div>
        </div>
      </div>

      <!-- Comparaison avec l'itinéraire optimisé -->
      <div class="route-comparison-section" *ngIf="optimizedRouteInfo">
        <h3>
          <i class="pi pi-chart-line"></i> Comparaison avec l'itinéraire
          optimisé
        </h3>
        <div class="comparison-grid">
          <div class="comparison-row">
            <div class="route-type">Itinéraire actuel</div>
            <div class="route-stats">
              {{
                distanceMatrix
                  ? getCurrentRouteDistance().distance.toFixed(1)
                  : routeInfo?.summary?.distance_km || 0
              }}
              km -
              {{
                formatDuration(
                  distanceMatrix
                    ? getCurrentRouteDistance().duration
                    : routeInfo?.summary?.duration_min || 0
                )
              }}
            </div>
          </div>
          <div class="comparison-row optimized">
            <div class="route-type">Itinéraire optimisé</div>
            <div class="route-stats">
              {{ optimizedRouteInfo.summary.distance_km }} km -
              {{ formatDuration(optimizedRouteInfo.summary.duration_min) }}
            </div>
          </div>
          <div
            class="comparison-row savings"
            *ngIf="
              routeInfo.summary.distance_km >
              optimizedRouteInfo.summary.distance_km
            "
          >
            <div class="route-type">Économies</div>
            <div class="route-stats savings-text">
              -{{
                (
                  routeInfo.summary.distance_km -
                  optimizedRouteInfo.summary.distance_km
                ).toFixed(1)
              }}
              km (-{{
                (
                  routeInfo.summary.duration_min -
                  optimizedRouteInfo.summary.duration_min
                ).toFixed(0)
              }}
              min)
            </div>
          </div>
        </div>
      </div>

      <!-- Étapes détaillées avec matrice de distances -->
      <div
        class="route-steps-section"
        *ngIf="distanceMatrix && getRouteStepsWithDistances().length > 0"
      >
        <h3>
          <i class="pi pi-map"></i> Étapes de l'itinéraire (matrice de
          distances)
        </h3>
        <div class="steps-list">
          <div
            class="step-item"
            *ngFor="let step of getRouteStepsWithDistances(); let i = index"
            [class.return-step]="step.isReturn"
          >
            <div class="step-number">{{ step.stepNumber }}</div>
            <div class="step-content">
              <div class="step-instruction">
                {{ step.from }} → {{ step.to }}
              </div>
              <div class="step-details">
                <span class="distance">{{ step.distance.toFixed(1) }} km</span>
                <span class="duration">{{
                  formatDuration(step.duration)
                }}</span>
                <span class="time" *ngIf="step.intervention && !step.isReturn">
                  à {{ step.intervention.start | date: 'HH:mm' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Étapes détaillées des API existantes -->
      <div
        class="route-steps-section"
        *ngIf="routeInfo?.steps && !distanceMatrix"
      >
        <h3><i class="pi pi-map"></i> Étapes de l'itinéraire</h3>
        <div class="steps-list">
          <div
            class="step-item"
            *ngFor="let step of routeInfo.steps; let i = index"
          >
            <div class="step-number">{{ i + 1 }}</div>
            <div class="step-content">
              <div class="step-instruction">{{ step.instruction }}</div>
              <div class="step-details">
                <span class="distance">{{ step.distance_km }} km</span>
                <span class="duration">{{
                  formatDuration(step.duration_min)
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Étapes optimisées si disponibles -->
      <div class="route-steps-section" *ngIf="optimizedRouteInfo?.steps">
        <h3><i class="pi pi-map"></i> Étapes de l'itinéraire optimisé</h3>
        <div class="steps-list">
          <div
            class="step-item optimized-step"
            *ngFor="let step of optimizedRouteInfo.steps; let i = index"
          >
            <div class="step-number">{{ i + 1 }}</div>
            <div class="step-content">
              <div class="step-instruction">{{ step.instruction }}</div>
              <div class="step-details">
                <span class="distance">{{ step.distance_km }} km</span>
                <span class="duration">{{
                  formatDuration(step.duration_min)
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
